<template>
    <div class="commdityWrap2" :id="'floor'+floor">
        <div class="top clearfix">
            <h2 class="title fl floor"><em class="floorLeftEM">{{index}}</em><em class="floorRightEM">F</em>{{ prop.name }}</h2>
            <template>
                <div class="tabWrap pr clearfix fr floorItem">
                    <div class="leftContent fl">
                        <img :src="prop.image" />
                    </div>
                    <el-tabs v-model="activeName" @tab-click="handleClick"  class="">
                        <el-tab-pane :name="String(index)" v-for="(item,index) in prop.child" :key="index" :label="item.name">

                            <div class="commdityContent clearfix tabsContainer">

                                <ul class="commdityUl clearfix fl">
                                    <li class="fl commdity pr" v-for="(goods, index) in item.child" :key="index">
                                        <router-link :to="'/goodDetail/'+goods.goods_id" target="_blank" class="clearfix">
                                            <div class="mask"></div>
                                            <div class="imgBox tc">
                                                <img :src="goods.image | thumbnailUrl" alt="" />
                                            </div>
                                            <div class="colorBlue f14 goods_name">{{goods.common_name}}<span v-if="goods.goods_name!==''">({{ goods.goods_name }})</span></div>
                                            <!--<div class="price colorRed f13">￥ {{ goods.market_price }}</div>-->
                                            <div>规格:{{ goods.goods_spec }}</div>
                                            <div class="company">产商:{{ goods.manufacturer_name }}</div>
                                            <!--<div>采购价:<span class="colorRed" v-text="goods.wholesale_price==='登录可见'?'登录可见':'￥'+ goods.wholesale_price"></span></div>-->
                                        </router-link>
                                    </li>
                                </ul>
                            </div>

                        </el-tab-pane>
                    </el-tabs>
                </div>
            </template>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'commditList2',
    props: ['prop','floor', 'index'],
    data() {
      return {
        activeName: "0",
        arrawLeft: '33px',
        goodsList: [],
      };
    },
    methods: {
      handleClick(tab) {
        this.arrawLeft = 33+(tab.index*86) + 'px'
      },
      toDetail(data) {
          this.$router.push(`/goodDetail/${data.goods_id}`);
      }
    },
    created() {
        if(this.prop.child.length>0){
            this.prop.child.forEach(val=>{
                val.child.forEach(v=>{
                    if(v.common_name.indexOf('（')>0||v.common_name.indexOf('(')>0) {
                        v.child.goods_name = ''
                    }
                })
                
            })
        }
     }
}
</script>

<style lang="scss" scoped>
    .commdityWrap2{
        margin-top: 6px;
        min-height: 582px;
    }
    .title{
        text-indent: 5px;
        height: 44px;
        line-height: 30px;
        margin-top: 5px;
        margin-bottom: -44px;
        font-weight: 700;
        font-size: 18px;
    }
    .hot{
        background: url('../../assets/images/icon/hotIcon.png') left center no-repeat;
        background-size: 20px;
    }
    .commdityContent {
        min-height: 529px;
    }
    .commdity{
        width: 236px;
        text-align: left;
        margin-right: -1px;
        margin-bottom: -1px;
        border: 1px solid #e3e2e1;
        height: 263px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        transition: all .2s ease-in;
    }
    .commdity>a{
        padding: 10px 0px 10px 20px;
    }
    .commdity .goods_name{
        width: 218px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .commdity .mask{
        background: #000;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0.04;
        display: none;
    }
    .commdity:hover{
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1)
    }
    .commdity:hover .mask{
    }
    .commdity .imgBox {
        height: 130px;
        width: 130px;
        margin: 0 auto;
    }
    .commdity img{
        height: 130px;
        width: 130px;
        transform: scale(1.3);
        position: relative;
        z-index: -1;
        margin: 0 auto;
    }
    .commdity .company{
        width: 180px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .commdity:nth-child(n+5){
        border-bottom: 1px solid #e3e2e1;

    }
    .commdityTitle{
        margin: 5px 0;
    }
    .commdityWrap2 .tabs__item .is-active{
        color: #fff;
        background: #1177b6
    }
    .commdityWrap2 .commdityUl{
        width: 950px;
    }
    .floorLeftEM,.floorRightEM{
        width: 21px;
        height: 26px;
        line-height: 26px;
        background: #1177b6;
        display: inline-block;
        text-align: center;
        color: #fff;
        text-indent: 0;
        border-radius: 8px 0 0 8px;
        margin-right: 3px;
    }
    .floorRightEM{
        border-radius: 0 8px 8px 0;
    }
    .leftContent{
        width: 250px;
        display: flex;
        align-items: flex-end;
    }
    .leftContent img{
        width: 100%;
        height: 263px * 2;
    }
    .tabWrap{
        & /deep/ .el-tabs__nav {
            float: right;
        }
    }
    
    .floorItem {
        display: flex;
        .tabsContainer {
            display: flex;
        }
    }
</style>

<style>
    .commdityWrap2 .el-tabs__nav-wrap::after{
        background: transparent;
    }
    .commdityWrap2 .el-tabs__item{
        height: 30px;
        line-height: 30px;
        padding-left: 15px!important;
        padding-right: 15px!important;
    }
    .commdityWrap2 .el-tabs__item.is-active{
        color: #fff;
        background: #1177b6;
        text-align: center;
    }
    .commdityWrap2 .tabArrow{
        content: "\e790";
        font-size: 20px;
        width: 20px;
        height: 20px;
        display: block;
        top: 21px;
        position: absolute;
        color: #1177b6;
        bottom:-10px;
    }
    .commdityWrap2 .el-tabs__active-bar.is-top{
        display: none;
    }
</style>